import { useQuery, useQueryClient, type UseQueryOptions } from '@tanstack/react-query';
import type { CertificationsQueryVariables } from '__generated__/graphql';
import { useCertificationRequest } from 'hooks/models/certification/useCertificationQuery/useCertificationRequest';
import useReactQueryBaseKey from 'hooks/react-query/useReactQueryBaseKey/useReactQueryBaseKey';

export function useCertificationQueryKey(variables: CertificationsQueryVariables) {
  return [...useReactQueryBaseKey(), 'CertificationsQuery', variables];
}

export const useCertificationQueryInvalidation = (variables: CertificationsQueryVariables) => {
  const queryKey = useCertificationQueryKey(variables);
  const client = useQueryClient();

  return () => client.invalidateQueries({ queryKey });
};

export type IUseCertificationRequestResult = Awaited<ReturnType<ReturnType<typeof useCertificationRequest>>>;

export interface IUseCertificationsQueryOptions {
  variables?: CertificationsQueryVariables;
  options?: Partial<UseQueryOptions<IUseCertificationRequestResult>>;
}
export function useCertificationQuery(props?: IUseCertificationsQueryOptions) {
  const { variables = {}, options = {} } = props || {};

  const request = useCertificationRequest();
  const queryKey = useCertificationQueryKey(variables);
  const queryFn = () => request(variables);

  return useQuery<IUseCertificationRequestResult>({
    ...options,
    queryKey,
    queryFn,
  });
}
